import { useState, useEffect } from 'react';
import { DiaryEntrySyncStatus } from 'graphql/types';
import { SmartDiaryEntry } from '../type';
import { useSmartDiaryDrawerContext } from '../SmartDiaryList/SmartDiaryDrawerContextProvider';

type UseUpdateExpandCollapseOnInitialLoadArgs = {
  loading: boolean;
  smartEntriesByDay: Record<string, SmartDiaryEntry[]>;
};

export const useUpdateExpandCollapseOnInitialLoad = ({
  loading,
  smartEntriesByDay
}: UseUpdateExpandCollapseOnInitialLoadArgs): void => {
  const { expanded, setExpanded } = useSmartDiaryDrawerContext();

  const [
    checkForPendingUpdatesOnInitialLoad,
    setCheckForPendingUpdatesOnInitialLoad
  ] = useState<boolean>(true);
  useEffect(() => {
    if (!loading && smartEntriesByDay && checkForPendingUpdatesOnInitialLoad) {
      const entries = Object.values(
        smartEntriesByDay
      ).flat() as SmartDiaryEntry[];
      const hasAtleastOneUpdateToBeApplied = entries.find(
        (entry: SmartDiaryEntry) =>
          entry.syncStatus !== DiaryEntrySyncStatus.Synced
      );
      if (!expanded && hasAtleastOneUpdateToBeApplied) {
        setExpanded(true);
      }
      setCheckForPendingUpdatesOnInitialLoad(false);
    }
  }, [
    checkForPendingUpdatesOnInitialLoad,
    expanded,
    setExpanded,
    smartEntriesByDay,
    loading
  ]);
};
